import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { AgentsComponent } from './agents/agents.component';
import { BlogComponent } from './blog/blog.component';
import { BlogSingleComponent } from './blog-single/blog-single.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PropertiesComponent } from './properties/properties.component';
import { PropertiesSingleComponent } from './properties-single/properties-single.component';
import { SupportComponent } from './support/support.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { HomeComponent } from './home/home.component';
import { SharedService } from './service/shared.service';
import { SignupComponent } from './signup/signup.component';
import { CreatePropertyComponent } from './create-property/create-property.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ProfileviewComponent } from './profileview/profileview.component';
import { SearchPropertyListComponent } from './search-property-list/search-property-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonPropertyComponent } from './common-property/common-property.component';
import { ApiServiceService } from './service/api-service.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { FavouriteListComponent } from './favourite-list/favourite-list.component';
import { InquiryListComponent } from './inquiry-list/inquiry-list.component';
import { PropertyViewComponent } from './property-view/property-view.component';
import { GallaryOfImageComponent } from './gallary-of-image/gallary-of-image.component';
import { FeaturedPropertiesComponent } from './featured-properties/featured-properties.component';
import { SwiperModule } from 'swiper/angular';

import { ExampleSwiperComponent } from './example-swiper/example-swiper.component';
import { CommonFeaturedPropertyComponent } from './common-featured-property/common-featured-property.component';
import { AuthGuardService } from './service/auth-guard.service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PropertieViewComponent } from './propertie-view/propertie-view.component';
import { CapitalizePipe } from './pipe/capitalize.pipe';
import { ContactUsModelComponent } from './contact-us-model/contact-us-model.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { SubscriptionOwnerPlanComponent } from './subscription-owner-plan/subscription-owner-plan.component';
import { SubscriptionBuyerPlanComponent } from './subscription-buyer-plan/subscription-buyer-plan.component';
import { SubscriptionSellerPlanComponent } from './subscription-seller-plan/subscription-seller-plan.component';
import { SignupModalComponent } from './signup-modal/signup-modal.component';
import { SubscriptionTenantPlanComponent } from './subscription-tenant-plan/subscription-tenant-plan.component';
import { NewFeaturedPropertiesComponent } from './new-featured-properties/new-featured-properties.component';
import { PaymentStatusPageComponent } from './payment-status-page/payment-status-page.component';
import { LoaderComponent } from './loader/loader.component';
import { SocialLoginModule, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import {
  GoogleLoginProvider,
  FacebookLoginProvider
} from '@abacritt/angularx-social-login';
import { environment } from 'src/environments/environment';
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FaqComponent } from './faq/faq.component';
import { CareersComponent } from './careers/careers.component';
import { NgxEditorModule } from 'ngx-editor';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { DisclamersComponent } from './disclamers/disclamers.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { PaymentTermsAndConditionsComponent } from './payment-terms-and-conditions/payment-terms-and-conditions.component';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ContactedPropertiesComponent } from './contacted-properties/contacted-properties.component';
import { PaymentCouponComponent } from './payment-coupon/payment-coupon.component';
import { GoogleMapComponent } from './google-map/google-map.component';
import { SafePipe } from './safe.pipe';
import { DeveloperViewComponent } from './developer-view/developer-view.component';
import { DeveloperComponent } from './developer/developer.component';
import { DirektVirtualTourComponent } from './direkt-virtual-tour/direkt-virtual-tour.component';
import { ReviewsViewComponent } from './reviews-view/reviews-view.component';
import { NewPropertyListComponent } from './new-property-list/new-property-list.component';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    AgentsComponent,
    BlogComponent,
    ContactComponent,
    FooterComponent,
    HeaderComponent,
    PropertiesComponent,
    PropertiesSingleComponent,
    SupportComponent,
    TermsConditionsComponent,
    HomeComponent,
    BlogSingleComponent,
    SignupComponent,
    CreatePropertyComponent,
    ResetpasswordComponent,
    ForgotpasswordComponent,
    ProfileviewComponent,
    SearchPropertyListComponent,
    CommonPropertyComponent,
    LoginComponent,
    FavouriteListComponent,
    InquiryListComponent,
    PropertyViewComponent,
    GallaryOfImageComponent,
    FeaturedPropertiesComponent,
    ExampleSwiperComponent,
    CommonFeaturedPropertyComponent,
    ChangePasswordComponent,
    PropertieViewComponent,
    ContactUsModelComponent,
    CapitalizePipe,
    SubscriptionPlansComponent,
    SubscriptionOwnerPlanComponent,
    SubscriptionBuyerPlanComponent,
    SubscriptionSellerPlanComponent,
    SignupModalComponent,
    SubscriptionTenantPlanComponent,
    NewFeaturedPropertiesComponent,
    PaymentStatusPageComponent,
    LoaderComponent,
    FaqComponent,
    CareersComponent,
    CookiePolicyComponent,
    SetPasswordComponent,
    DisclamersComponent,
    PrivacyPolicyComponent,
    DeleteAccountComponent,
    PaymentTermsAndConditionsComponent,
    PaymentListComponent,
    InvoiceListComponent,
    InvoiceComponent,
    SubscriptionComponent,
    ContactedPropertiesComponent,
    PaymentCouponComponent,
    GoogleMapComponent,
    SafePipe,
    DeveloperViewComponent,
    DeveloperComponent,
    DirektVirtualTourComponent,
    ReviewsViewComponent,
    NewPropertyListComponent
  ],
  providers: [SharedService, ApiServiceService, HttpClient, AuthGuardService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.GOOGLE_CLIENT_ID
            )
          },
          // {
          //   id: FacebookLoginProvider.PROVIDER_ID,
          //   provider: new FacebookLoginProvider(
          //     environment.FACEBOOK_CLIENT_ID
          //   )
          // }
        ],
        onError: (err) => {
          console.error('SocialAuthServiceConfig: ',err);
        }
      } as SocialAuthServiceConfig,
    }],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    HttpClientModule,
    SocialLoginModule,
    TagInputModule,
    BrowserAnimationsModule,
    NgxEditorModule,
    ToastrModule.forRoot(),
    
    // TagInputModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
